import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aa355da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommendations" }
const _hoisted_2 = { class: "recommendations__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__content-title" }, "Рекомендации", -1))
const _hoisted_4 = { class: "recommendations__content-item recommendations__next-hygiene" }
const _hoisted_5 = {
  key: 0,
  class: "recommendations__appoint-consultation"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__content-item recommendations__consultation" }, " 2. Консультация стоматолога: ", -1))
const _hoisted_7 = {
  key: 1,
  class: "recommendations__appoint-consultation"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "recommendations__content-item recommendations__consultation" }, " 3. Мероприятия для оценки десен и обучения: ", -1))
const _hoisted_9 = { class: "recommendations__footer" }

import { computed, PropType, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ConsultationType } from '@/shared/types'
import { declination } from '@/shared/utils'
import { FSaveRecommendations } from '@/features/FSaveRecommendations'
import { CONSULTATIONS_MAP, MEASURES_MAP } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  consultation: Object as PropType<ConsultationType>,
  isPlaqueReport: Boolean,
  isPeriodontalReport: Boolean,
},
  emits: ['saved'],
  setup(__props, { emit }) {

const props = __props





const route = useRoute()

const reCleaning = ref(props.consultation.reCleaning)
const consultationList = ref([...props.consultation.consultations])
const selectedConsultations = ref(
  props.consultation.consultations.filter((consultation) =>
    CONSULTATIONS_MAP.has(consultation)
  )
)
const selectedMeasures = ref(
  props.consultation.consultations.filter((consultation) =>
    MEASURES_MAP.has(consultation)
  )
)
const doctorConsultationList = computed(() => {
  return Object.keys(props.consultation.fullConsultationList).filter(
    (consultation) => CONSULTATIONS_MAP.has(consultation)
  )
})
const measuresList = computed(() => {
  return Object.keys(props.consultation.fullConsultationList).filter(
    (consultation) => MEASURES_MAP.has(consultation)
  )
})

watch(selectedConsultations, () => {
  consultationList.value = [
    ...selectedConsultations.value,
    ...selectedMeasures.value,
  ]
})

watch(selectedMeasures, () => {
  consultationList.value = [
    ...selectedConsultations.value,
    ...selectedMeasures.value,
  ]
})

const reportId = computed(() => Number(route.params.reportId))

const signature = computed(() =>
  declination(reCleaning.value, ['месяц', 'месяца', 'месяцев'])
)

const handleSaveRecommendations = async (): Promise<void> => {
  emit('saved')
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode(" 1. " + _toDisplayString(__props.isPeriodontalReport
            ? 'Следующий приём через'
            : 'Следующая профессиональная гигиена зубов через') + " ", 1),
        _createVNode(_component_el_select, {
          modelValue: reCleaning.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reCleaning).value = $event)),
          size: "small"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (item) => {
              return _createVNode(_component_el_option, { value: item }, null, 8, ["value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createTextVNode(" " + _toDisplayString(_unref(signature)), 1)
      ]),
      (__props.isPlaqueReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_checkbox_group, {
              modelValue: selectedConsultations.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedConsultations).value = $event)),
              class: "recommendations__dentists"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(doctorConsultationList), (consultation, key) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    label: consultation,
                    class: "recommendations__dentists-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(CONSULTATIONS_MAP).get(consultation)), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      (__props.isPlaqueReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_checkbox_group, {
              modelValue: selectedMeasures.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedMeasures).value = $event)),
              class: "recommendations__dentists"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(measuresList), (measure, key) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    label: measure,
                    class: "recommendations__dentists-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(MEASURES_MAP).get(measure)), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(FSaveRecommendations), {
        "is-plaque-report": __props.isPlaqueReport,
        consultations: consultationList.value,
        "re-cleaning": reCleaning.value,
        "report-id": _unref(reportId),
        onSaved: handleSaveRecommendations
      }, null, 8, ["is-plaque-report", "consultations", "re-cleaning", "report-id"])
    ])
  ]))
}
}

})